module finadai.app.admin.cancel_negotiation {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.cancel_negotiation"

    function AdminCancelNegotiationController(customersService: services.CustomersService,
                                              whoIAm: models.User, $rootScope, $scope,
                                              notify, confirm, $mdDialog: ng.material.IDialogService,
                                              $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                              proxifier, $q: ng.IQService, authService: services.AuthService) {
        $scope.formData = {};
        $scope.cancelNegotiationData = {};
        $scope.cancelingNegotiation = false;
        $scope.messageCustomer = "";


        $scope.canCancelNegotiationForCustomer = whoIAm.operations.indexOf('admin_cancel_negotiation') >= 0;
        $scope.cancelNegotiation = (form) => {
            if (form.$valid) {
                $scope.cancelingNegotiation = true;
                customersService.proxyGetCustomer({customer_number: $scope.cancelNegotiationData.customer_number})
                    .then(function (response) {
                        $scope.search_customer = response.data;
                        console.log(response.data);

                    }, function () {
                        $scope.cancelingNegotiation = false;
                    })
                    .then(function () {
                        customersService.proxyCancelNegotiation({
                            customer_number: $scope.cancelNegotiationData.customer_number,
                            reason_id: 3,
                            user_id: whoIAm.id,
                            is_admin: true
                        })
                            .then(function (response) {
                                    notify('Convenio Cancelado');
                                    $scope.cancelingNegotiation = false;
                                    this.cancelNegotiationForm.reset();
                                }, function (response) {
                                    notify('Fallo Cancelar Convenio', 'danger');
                                    $scope.cancelingNegotiation = false;
                                }
                            );
                    }, function () {
                        $scope.cancelingNegotiation = false;
                    })
            }
        };
    }

    export function run() {
        var cancel = angular.module(NAME, [])
        cancel.controller("AdminCancelNegotiationController", AdminCancelNegotiationController)
    }
}
finadai.app.admin.cancel_negotiation.run();